import React, { useState, useContext, useEffect } from "react"
import Context from "../utils/Context"
import JoystickManual from "../components/JoystickManual"
import Maps from "../pages/Maps/Maps"
import Tasks from "../components/Tasks"
import Settings from "../components/Settings"
import Orders from "../components/Orders"
import Import from "../pages/Dashboard/Import"
import Missions from "../components/Missions"
import Store from "../components/Store"
import Warehouse from "../components/Warehouse"
import FoodLabMenu from "../components/FoodlabMenu"
import Rviz from "../components/Rviz"
import PoseEstimate from "../components/PoseEstimate"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Commands from "../components/Commands"
import { faColumns, faCogs, faClipboardCheck, faGamepad, faMapMarkerAlt, faFileUpload, faPlay, faStore, faWarehouse, faBowlFood, faLocationArrow } from '@fortawesome/free-solid-svg-icons'


export default function RobotMenu() {

  const context = useContext(Context)

  // state
  const inicitial = ((window.innerWidth < 800 && window.innerHeight > 600) ? true : false)
  const [selectedMenu, setSelectedMenu] = useState("maps")
  //const [orientation, setOrientation] = useState(inicitial)

  useEffect(() => {
    switch (selectedMenu) {
      case "orders":
        if (!context.features[0]) setSelectedMenu("tasks")
        break

      case "missions":
      case "settings":
        if (!context.features[1]) setSelectedMenu("tasks")
        break

      case "store":
      case "warehouse":
        if (!context.features[2]) setSelectedMenu("tasks")
        break

      case "foodlab":
        if (!context.features[3]) setSelectedMenu("tasks")
        break

      default:
        break
    }
  }, [context.features])

  if (!context.isRobotConnected) return null

  return (
    <>
      <div className="mb-5 is-flex is-justify-content-space-evenly" style={{ flexWrap: "wrap" }}>

        <button
          className={
            selectedMenu === "maps"
              ? "button has-background-light is-active mb-2 mr-2 is-size-7"
              : "button is-link mb-2 mr-2 is-size-7"
          }
          onClick={() => setSelectedMenu("maps")}
          disabled={context.lastMission === 'select-map' && !context.endOfMission}
        >
          <FontAwesomeIcon icon={faMapMarkerAlt} className="is-small mr-2" />
          Maps
        </button>

        {context.features[0] && (
          <button
            className={
              selectedMenu === "orders"
                ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                : "button is-link mb-2 mr-2 is-size-7"
            }
            onClick={() => setSelectedMenu("orders")}
            disabled={context.lastMission === 'select-map' && !context.endOfMission}
          >
            <FontAwesomeIcon icon={faColumns} className="is-small mr-2" />
            Orders
          </button>
        )}

        {//context.selectedRobot?.typeRobot !== "FI-250" && (
          <button
            onClick={() => setSelectedMenu("tasks")}
            disabled={context.lastMission === 'select-map' && !context.endOfMission}
            className={
              selectedMenu === "tasks"
                ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                : "button is-link mb-2 mr-2 is-size-7"
            }
          >
            <FontAwesomeIcon icon={faClipboardCheck} className="is-small mr-2" />
            Tasks
          </button>
          //)
        }

        {context.features[1] &&
          <button
            onClick={() => setSelectedMenu("missions")}
            disabled={context.lastMission === 'select-map' && !context.endOfMission}
            className={
              selectedMenu === "missions"
                ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                : "button is-link mb-2 mr-2 is-size-7"
            }
          >
            <FontAwesomeIcon icon={faPlay} className="is-small mr-2" />
            Missions
          </button>
        }

        {context.features[2] &&
          <>
            <button
              onClick={() => setSelectedMenu("store")}
              disabled={context.lastMission === 'select-map' && !context.endOfMission}
              className={
                selectedMenu === "store"
                  ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                  : "button is-link mb-2 mr-2 is-size-7"
              }
            >
              <FontAwesomeIcon icon={faStore} className="is-small mr-2" />
              Store
            </button>

            <button
              onClick={() => setSelectedMenu("warehouse")}
              disabled={context.lastMission === 'select-map' && !context.endOfMission}
              className={
                selectedMenu === "warehouse"
                  ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                  : "button is-link mb-2 mr-2 is-size-7"
              }
            >
              <FontAwesomeIcon icon={faWarehouse} className="is-small mr-2" />
              Warehouse
            </button>
          </>
        }

        {context.features[3] && context.isRobotConnected &&
          <button
            onClick={() => setSelectedMenu("foodlab")}
            disabled={context.lastMission === 'select-map' && !context.endOfMission}
            className={
              selectedMenu === "foodlab"
                ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                : "button is-link mb-2 mr-2 is-size-7"
            }
          >
            <FontAwesomeIcon icon={faBowlFood} className="is-small mr-2" />
            Journeys
          </button>
        }

        <button
          className={
            selectedMenu === "manual"
              ? "button has-background-light is-active mb-2 mr-2 is-size-7"
              : "button is-link mb-2 mr-2 is-size-7"
          }
          onClick={() => setSelectedMenu("manual")}
          disabled={context.lastMission === 'select-map' && !context.endOfMission}
        >
          <FontAwesomeIcon icon={faGamepad} className="is-small mr-2" />
          Manual
        </button>

        {context.selectedRobot?.typeRobot === "FI-250" &&

          <button
            className={
              selectedMenu === "import"
                ? "button has-background-light is-active  mb-2 mr-2 is-size-7"
                : "button is-link  mb-2 mr-2 is-size-7"
            }
            onClick={() => setSelectedMenu("import")}
            disabled={context.lastMission === 'select-map' && !context.endOfMission}
          >
            <FontAwesomeIcon icon={faFileUpload} className="is-small mr-2" />
            Import
          </button>
        }

        {context.settings.fmsConnection && context.features[1] &&

          <button
            className={
              selectedMenu === "settings"
                ? "button has-background-light is-active  mb-2 mr-2 is-size-7"
                : "button is-link  mb-2 mr-2 is-size-7"
            }
            onClick={() => setSelectedMenu("settings")}
            disabled={context.lastMission === 'select-map' && !context.endOfMission}
          >
            <FontAwesomeIcon icon={faCogs} className="is-small mr-2" />
            Area Settings
          </button>
        }

        {context.user?.roles.find(role => role === "admin") && (
          <>
            <button
              className={
                selectedMenu === "commands"
                  ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                  : "button is-link mb-2 mr-2 is-size-7"
              }
              onClick={() => setSelectedMenu("commands")}

            >
              <FontAwesomeIcon icon={faCogs} className="is-small mr-2" />
              Commands
            </button>

            <button
              className={
                selectedMenu === "rviz"
                  ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                  : "button is-link mb-2 mr-2 is-size-7"
              }
              onClick={() => setSelectedMenu("rviz")}

            >
              <FontAwesomeIcon icon={faCogs} className="is-small mr-2" />
              Rviz
            </button>

            <button
              className={
                selectedMenu === "poseestimate"
                  ? "button has-background-light is-active mb-2 mr-2 is-size-7"
                  : "button is-link mb-2 mr-2 is-size-7"
              }
              onClick={() => setSelectedMenu("poseestimate")}

            >
              <FontAwesomeIcon icon={faLocationArrow} className="is-small mr-2" />
              2D Pose Estimate
            </button>
          </>
        )}
      </div>

      <div className="panel">

        {selectedMenu === "manual" && !context.modalState.configuration ?
          <JoystickManual />
          : selectedMenu === "maps" ?
            <Maps />
            : selectedMenu === "settings" ?
              <Settings />
              : selectedMenu === "import" ?
                <Import />
                : selectedMenu === "orders" ?
                  <Orders />
                  : selectedMenu === "tasks" ?
                    <Tasks />
                    : selectedMenu === "missions" ?
                      <Missions />
                      : selectedMenu === "store" ?
                        <Store />
                        : selectedMenu === "warehouse" ?
                          <Warehouse />
                          : selectedMenu === "commands" ?
                            <Commands />
                            : selectedMenu === "rviz" ?
                              <Rviz />
                              : selectedMenu === "poseestimate" ?
                                <PoseEstimate />
                                : selectedMenu === "foodlab" ?
                                  <FoodLabMenu />
                                  : ""

        }

      </div>
    </>
  )
}
